import React from "react"
import { useNavigate as useNavigateOriginal } from "react-router-dom"
import type { NavigateFunction } from "react-router-dom"

/**
 * React Router useNavigate returns a new function on every location change, causing everything that depends on it to
 * re-render. Navigator's <Item>s for example are re-rendered every time a new product is selected: they are memoized
 * and their properties don't change (except the newly selected product), but they rely on useNavigate.
 *
 * This hook returns an invariant function. I'm not sure what we lose by doing this, but the React Router team has
 * created a change request for useNavigate to return an invariant function too:
 * https://github.com/remix-run/react-router/discussions/9588.
 * We can remove this hook when the change request is implemented.
 */

const useNavigateNoUpdate = (): NavigateFunction => {
  const navigate = useNavigateOriginal()
  const navigateRef = React.useRef(navigate)
  return navigateRef.current
}

export default useNavigateNoUpdate
